import { render, staticRenderFns } from "./Addwrokspaceinput.vue?vue&type=template&id=1253f6ad&scoped=true"
import script from "./Addwrokspaceinput.vue?vue&type=script&lang=js"
export * from "./Addwrokspaceinput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1253f6ad",
  null
  
)

export default component.exports